<template>

    <vx-card :title='$t("Meetings")'>

        <div class="flex flex-wrap justify-between items-center">

            <!-- ITEMS PER PAGE -->
            <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

                <vs-dropdown v-if="this.gridApi" vs-trigger-click class="cursor-pointer">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ gridApi.getDisplayedRowCount() - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : gridApi.getDisplayedRowCount() }} of {{ gridApi.getDisplayedRowCount() }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                            <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                            <span>150</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>

                <div style="float:right;" v-if="meetings">
                    <vs-button v-if="$checkPermission(2002)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" class="ml-6 mt-1" @click="addMeetingPrompt = true">{{$t("Add")}}</vs-button>
                </div>

            </div>


            <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                <vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"/>
            </div>
        </div>

        <ag-grid-vue
                ref="agGridTable"
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="meetings"
                rowSelection="multiple"
                colResizeDefault="shift"
                domLayout="autoHeight"
                :animateRows="true"
                :floatingFilter="true"
                :pagination="true"
                :paginationPageSize="paginationPageSize"
                :suppressPaginationPanel="true">
        </ag-grid-vue>
        <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage" />

        <vs-popup :title="$t('Add')" :active.sync="addMeetingPrompt">
            <div>
                <p class="mt-6">{{$t("Title")}}</p>
                <vs-input v-model="addMeetingTitle" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Client")}}</p>
                <vs-select autocomplete style="width: 100%" class="selectExample" v-model="addMeetingClient">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in this.$store.getters.companyClients" />
                </vs-select>
                <p class="mt-6">{{$t("StartTime")}}</p>
                <flat-pickr :config="configDateTimePicker" v-model="addMeetingDeadline"/>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addMeeting">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

    </vx-card>

</template>
<script>

    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import { AgGridVue } from "ag-grid-vue"
    import StatusRenderer from "./StatusRenderer";
    import TimeRenderer from "./TimeRenderer";
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {
            AgGridVue,
            StatusRenderer,
            TimeRenderer,
            flatPickr
        },
        props: {
            listType: {
                type: String,
                required: true
            },
        },
        data(){
            return {

                meetings: null,

                configDateTimePicker: {
                    enableTime: true,
                    dateFormat: 'Y-m-d H:i',
                    locale: {
                        firstDayOfWeek: 1
                    }
                },

                addMeetingPrompt: false,
                addMeetingTitle: '',
                addMeetingClient: 0,
                addMeetingDeadline: null,


                searchQuery: '',
                gridOptions: {
                    suppressRowClickSelection: true,
                    onCellClicked: (e) => {
                        this.$router.push({ name: 'meeting', params: { id: "" + e.data.id } })
                    },
                    onRowDataChanged: () => {
                        this.$nextTick(() => {
                            this.gridColumnApi.autoSizeColumns(['title', 'client_company_id', 'company_user_id', 'status', 'start_time', 'time_added']);
                            if(this.columnsWidth < this.tableWidth){
                                this.gridApi.sizeColumnsToFit()
                            }
                        });
                    }
                },
                maxPageNumbers: 10,
                gridApi: null,
                gridColumnApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnDefs: [
                    {
                        headerName: this.$t("Title"),
                        field: 'title',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Client"),
                        field: 'client_company_id',
                        filter: true,
                        valueGetter: this.clientCompanyValueGetter,
                    },
                    {
                        headerName: this.$t("User"),
                        field: 'company_user_id',
                        filter: true,
                        valueGetter: this.userValueGetter,
                    },
                    {
                        headerName: this.$t("Status"),
                        field: 'status',
                        filter: true,
                        valueGetter: this.statusValueGetter,
                        cellRendererFramework: StatusRenderer,
                    },
                    {
                        headerName: this.$t("StartTime"),
                        field: 'start_time',
                        filter: true,
                        width: 150,
                        cellRendererFramework: TimeRenderer,
                    },
                    {
                        headerName: this.$t("DateAdded"),
                        field: 'time_added',
                        filter: true,
                        width: 150,
                        cellRendererFramework: TimeRenderer,
                    },
                ],
            }
        },
        computed: {
            columnsWidth() {
                let total = 0;
                let state = this.gridColumnApi.getColumnState();
                for(let x = 0; x < state.length; x++){
                    total += state[x].width
                }
                return total;
            },
            tableWidth() {
                return this.gridApi.gridPanel.eBodyViewport.clientWidth;
            },
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize();
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages();
                else return 0
            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1)
                }
            },
        },
        methods: {
            resizeColumns(){
                this.gridColumnApi.autoSizeColumns(['title', 'client_company_id', 'company_user_id', 'status', 'start_time', 'time_added']);
                if(this.columnsWidth < this.tableWidth){
                    this.gridApi.sizeColumnsToFit()
                }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            updateMeetings(){
                const thisIns = this;
                this.$http.get('/api/v1/meeting?type=' + this.listType)
                    .then(function (response) {
                        thisIns.meetings = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addMeeting(){
                const thisIns = this;
                this.$http.post('/api/v1/meeting', {
                    title: this.addMeetingTitle,
                    client_company_id: Number(this.addMeetingClient),
                    start_time: this.moment(this.addMeetingDeadline).format()
                })
                    .then(function (response) {
                        thisIns.addMeetingPrompt = false;
                        thisIns.$nextTick(() => {
                            thisIns.$router.push("/meeting/" + response.data)
                        });
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            clientCompanyValueGetter(param){
                return this.$store.getters.companyClients[param.data.client_company_id].name
            },
            userValueGetter(param){
                return this.$store.getters.companyUsers[param.data.company_user_id].name
            },
            statusValueGetter(param){
                switch(param.data.status){
                    case 0: return this.$t("MeetingPlanned");
                    case 1: return this.$t("MeetingInProgress");
                    case 2: return this.$t("MeetingStopped");
                    case 3: return this.$t("SentForConfirmation");
                    case 4: return this.$t("MeetingFinished");
                }
            }
        },
        watch: {
            listType: function () {
                this.updateMeetings();
            },
        },
        created() {
            this.updateMeetings()
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
        },

    }

</script>
